module.exports = __webpack_public_path__ + "img/slider_3_en.968b568a.jpg";